"use client";

import { c as _c } from "react/compiler-runtime";
import { useEmailComposer } from "../../context";
import { useRef } from "react";
import { Input } from "@/components/ui";
import { AIButton } from "./ai-button";
import { AlignDropdown } from "./align-button";
import { AttachmentButton } from "./attachment-button";
import { BoldButton } from "./bold-button";
import { BulletListButton } from "./bullet-list-button";
import { ClearFormattingButton } from "./clear-formatting-button";
import { FontFamilySelect } from "./font-family-select";
import { FontSizeSelect } from "./font-size-select";
import { HSeparator } from "./h-separator";
import { HeadingDropdown } from "./heading-dropdown";
import { ImageInsertButton } from "./image-insert-button";
import { IndentButton, OutdentButton } from "./indent-buttons";
import { ItalicButton } from "./italic-button";
import { LinkButton } from "./link-button";
import { OrderedListButton } from "./ordered-list-button";
import { OverflowMenu } from "./overflow-menu";
import { PaintFormatButton } from "./paint-format-button";
import { StrikethroughButton } from "./strikethrough-button";
import { TextColorButton } from "./text-color-button";
import { UnderlineButton } from "./underline-button";
function BackgroundControls() {
  const $ = _c(50);
  const {
    styleSettings,
    setStyleSettings
  } = useEmailComposer();
  const colorInputRef = useRef(null);
  const currentColor = styleSettings.containerBackgroundColor || "#ffffff";
  const paddingTop = styleSettings.containerPaddingTop;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="text-caption text-foreground-secondary whitespace-nowrap">Background</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => colorInputRef.current?.click();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== currentColor) {
    t2 = <button type="button" onClick={t1} title="Background color" className="h-6 w-6 rounded border border-border cursor-pointer shrink-0" style={{
      backgroundColor: currentColor
    }} />;
    $[2] = currentColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== setStyleSettings) {
    t3 = e => {
      setStyleSettings?.({
        containerBackgroundColor: e.target.value
      });
    };
    $[4] = setStyleSettings;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== currentColor || $[7] !== t3) {
    t4 = <input ref={colorInputRef} type="color" value={currentColor} onChange={t3} className="absolute right-0 top-0 h-full w-8 cursor-pointer opacity-0" title="Background color" />;
    $[6] = currentColor;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="relative flex items-center gap-1">{t0}{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex items-center gap-1"><span className="text-caption text-foreground-secondary whitespace-nowrap">Padding</span></div>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="text-caption text-foreground-secondary whitespace-nowrap">T</span>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== setStyleSettings) {
    t8 = e_0 => {
      const n = parseInt(e_0.target.value, 10);
      const val = isNaN(n) || n < 0 ? 0 : n;
      setStyleSettings?.({
        containerPaddingTop: val
      });
    };
    $[14] = setStyleSettings;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== paddingTop || $[17] !== t8) {
    t9 = <div className="flex items-center gap-1">{t7}<Input type="number" min={0} max={100} value={paddingTop} onChange={t8} placeholder="20" className="h-7 w-14 text-caption text-center px-1" /></div>;
    $[16] = paddingTop;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="text-caption text-foreground-secondary whitespace-nowrap">B</span>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== setStyleSettings) {
    t11 = e_1 => {
      const n_0 = parseInt(e_1.target.value, 10);
      const val_0 = isNaN(n_0) || n_0 < 0 ? 0 : n_0;
      setStyleSettings?.({
        containerPaddingBottom: val_0
      });
    };
    $[20] = setStyleSettings;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== styleSettings.containerPaddingBottom || $[23] !== t11) {
    t12 = <div className="flex items-center gap-1">{t10}<Input type="number" min={0} max={100} value={styleSettings.containerPaddingBottom} onChange={t11} placeholder="0" className="h-7 w-14 text-caption text-center px-1" /></div>;
    $[22] = styleSettings.containerPaddingBottom;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="text-caption text-foreground-secondary whitespace-nowrap">L</span>;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== setStyleSettings) {
    t14 = e_2 => {
      const n_1 = parseInt(e_2.target.value, 10);
      const val_1 = isNaN(n_1) || n_1 < 0 ? 0 : n_1;
      setStyleSettings?.({
        containerPaddingLeft: val_1
      });
    };
    $[26] = setStyleSettings;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== styleSettings.containerPaddingLeft || $[29] !== t14) {
    t15 = <div className="flex items-center gap-1">{t13}<Input type="number" min={0} max={100} value={styleSettings.containerPaddingLeft} onChange={t14} placeholder="0" className="h-7 w-14 text-caption text-center px-1" /></div>;
    $[28] = styleSettings.containerPaddingLeft;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <span className="text-caption text-foreground-secondary whitespace-nowrap">R</span>;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== setStyleSettings) {
    t17 = e_3 => {
      const n_2 = parseInt(e_3.target.value, 10);
      const val_2 = isNaN(n_2) || n_2 < 0 ? 0 : n_2;
      setStyleSettings?.({
        containerPaddingRight: val_2
      });
    };
    $[32] = setStyleSettings;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== styleSettings.containerPaddingRight || $[35] !== t17) {
    t18 = <div className="flex items-center gap-1">{t16}<Input type="number" min={0} max={100} value={styleSettings.containerPaddingRight} onChange={t17} placeholder="0" className="h-7 w-14 text-caption text-center px-1" /></div>;
    $[34] = styleSettings.containerPaddingRight;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <span className="text-caption text-foreground-secondary whitespace-nowrap">Width</span>;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== setStyleSettings) {
    t20 = e_4 => {
      const n_3 = parseInt(e_4.target.value, 10);
      const val_3 = isNaN(n_3) || n_3 < 200 ? 200 : n_3;
      setStyleSettings?.({
        maxWidth: val_3
      });
    };
    $[38] = setStyleSettings;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== styleSettings.maxWidth || $[41] !== t20) {
    t21 = <div className="flex items-center gap-1">{t19}<Input type="number" min={200} max={1600} step={10} value={styleSettings.maxWidth} onChange={t20} placeholder="600" className="h-7 w-16 text-caption text-center px-1" /></div>;
    $[40] = styleSettings.maxWidth;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t12 || $[44] !== t15 || $[45] !== t18 || $[46] !== t21 || $[47] !== t5 || $[48] !== t9) {
    t22 = <div className="flex items-center gap-3">{t5}{t6}{t9}{t12}{t15}{t18}{t21}</div>;
    $[43] = t12;
    $[44] = t15;
    $[45] = t18;
    $[46] = t21;
    $[47] = t5;
    $[48] = t9;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  return t22;
}
export function ToolbarMenu(t0) {
  const $ = _c(15);
  const {
    compact
  } = t0;
  const {
    editor,
    onImageUpload,
    onAddFiles,
    onAI,
    backgroundSelected
  } = useEmailComposer();
  if (!editor) {
    return null;
  }
  if (backgroundSelected) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <BackgroundControls />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const hasMediaButtons = onImageUpload || onAddFiles;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <BoldButton />;
    t2 = <ItalicButton />;
    t3 = <UnderlineButton />;
    t4 = <HSeparator />;
    t5 = <BulletListButton />;
    t6 = <OrderedListButton />;
    t7 = <IndentButton />;
    t8 = <OutdentButton />;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== compact || $[10] !== hasMediaButtons || $[11] !== onAI || $[12] !== onAddFiles || $[13] !== onImageUpload) {
    t9 = <>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{compact ? <div className="flex items-center"><HSeparator /><OverflowMenu /></div> : <div className="flex items-center"><HSeparator /><LinkButton />{hasMediaButtons && <><HSeparator />{onImageUpload && <ImageInsertButton />}{onAddFiles && <AttachmentButton />}</>}<HSeparator /><HeadingDropdown /><FontFamilySelect /><FontSizeSelect /><TextColorButton /><StrikethroughButton /><ClearFormattingButton /><PaintFormatButton /><HSeparator /><AlignDropdown />{onAI && <><HSeparator /><AIButton /></>}</div>}</>;
    $[9] = compact;
    $[10] = hasMediaButtons;
    $[11] = onAI;
    $[12] = onAddFiles;
    $[13] = onImageUpload;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}